// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Sentry = require("../../../reason/Sentry.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ReactErrorBoundary = require("react-error-boundary");

function FragmentErrorBoundary$ErrorState(props) {
  return JsxRuntime.jsx("div", {
              children: "⚠ Error retrieving " + props.fragmentDisplayName,
              className: "text-tan-error-500 font-medium"
            });
}

var ErrorState = {
  make: FragmentErrorBoundary$ErrorState
};

function FragmentErrorBoundary(props) {
  var fragmentDisplayName = props.fragmentDisplayName;
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: (function (_error) {
                  return JsxRuntime.jsx(FragmentErrorBoundary$ErrorState, {
                              fragmentDisplayName: fragmentDisplayName
                            });
                }),
              children: props.children,
              onError: (function (error) {
                  Sentry.captureException(error, "FragmentErrorBoundary.res", undefined, undefined, undefined);
                })
            });
}

var make = FragmentErrorBoundary;

exports.ErrorState = ErrorState;
exports.make = make;
/* Sentry Not a pure module */
